export class ComplementaryExam {
    name: string;
    description: string;
}